module.exports = "https://static.wmbcdn.com/uniweb/images/032648855a925f2abbbff8c7ea83eb32.svg";